module.exports = __webpack_public_path__ + "media/images/reminder-icon-b320d06f1ba2f5a8da174cad1c643219.png";